<template>
  <div>
    <vue-action-buttons :buttons="actionButtons" />

    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0">Ajouter une facture au dossier d'importation</h5>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-xl-4 col-12">
            <label for="">Facture <span class="text-danger">*</span></label>
            <vue-select
              :options="costs"
              v-model="selectedCost.cost_reference"
              placeholder="Sélectionner une facture"
              labelColumn="fullName"
              valueColumn="reference"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total TTC </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceTTC"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total HT </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceHT"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total TVA </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceTVA"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">TVA % </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.tva"
              class="form-control"
            />
          </div>
        </div>
        <br />
        <div class="row align-items-end">
          <div class="col-xl-3 col-12">
            <label for="">Méthode de paiement </label>
            <select v-model="selectedCost.paymentMethod" class="form-control">
              <option value="">Sélectionner</option>
              <option value="cash">Espèces</option>
              <option value="cheque">Chèque</option>
              <option value="virement">Virement</option>
              <option value="transfer">Transfert</option>
            </select>
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Date de paiement </label>
            <input
              type="date"
              v-model="selectedCost.paymentDate"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'cheque'"
          >
            <label for="">Numéro de chèque </label>
            <input
              type="text"
              v-model="selectedCost.cheque_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'virement'"
          >
            <label for="">Numéro de virement </label>
            <input
              type="text"
              v-model="selectedCost.virement_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'virement'"
          >
            <label for="">Date de virement </label>
            <input
              type="date"
              v-model="selectedCost.virementDate"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'transfer'"
          >
            <label for="">Numéro de transfert </label>
            <input
              type="text"
              v-model="selectedCost.transfer_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'transfer'"
          >
            <label for="">Date de transfert </label>
            <input
              type="date"
              v-model="selectedCost.transferDate"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Numéro de facture </label>
            <input
              type="text"
              v-model="selectedCost.invoice_number"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Fournisseur </label>
            <vue-select
              :options="suppliers"
              v-model="selectedCost.supplier_reference"
              placeholder="Sélectionner un fournisseur"
              labelColumn="fullName"
              valueColumn="reference"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">
              Facture
              <span class="badge bg-light text-primary border ms-1" style="font-size:0.7em;">
                <i class="bi bi-stars"></i> IA PDF/Image
              </span>
            </label>
            <div class="d-flex gap-2 align-items-center">
              <input
                type="file"
                ref="invoiceFileInput"
                @change="handleInvoiceFileChange"
                accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx"
                style="display: none"
              />
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="triggerInvoiceFileInput"
                :disabled="isAnalyzingAI"
              >
                <i class="bi bi-upload"></i>
                {{
                  selectedCost.invoice_file
                    ? "Fichier sélectionné"
                    : "Importer"
                }}
              </button>
              <button
                v-if="selectedCost.invoice_file && !isAnalyzingAI"
                type="button"
                class="btn btn-outline-danger"
                @click="removeInvoiceFile"
              >
                <i class="bi bi-x"></i>
              </button>
              <span v-if="isAnalyzingAI" class="d-flex align-items-center text-primary gap-1">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <small>Analyse IA en cours...</small>
              </span>
            </div>
            <small v-if="selectedCost.invoice_file && !isAnalyzingAI" class="text-muted d-block mt-1">
              <i class="bi bi-paperclip"></i> {{ selectedCost.invoice_file.name }}
            </small>
            <small v-if="!selectedCost.invoice_file && !isAnalyzingAI" class="text-muted d-block mt-1">
              PDF, JPG ou PNG — le formulaire sera rempli automatiquement
            </small>
            <small v-if="aiAnalysisError" class="text-warning d-block mt-1">
              <i class="bi bi-exclamation-triangle"></i> {{ aiAnalysisError }}
            </small>
          </div>

          <div class="col-xl-12 col-12">
            <label for="">Remarque </label>
            <textarea
              v-model="selectedCost.remark"
              class="form-control"
            ></textarea>
          </div>

          <div class="col-xl-auto col">
            <label for=""></label>
            <button
              class="btn btn-success"
              @click="addCost()"
              v-if="!editingCostReference"
            >
              <i class="bi bi-plus-circle"></i> Ajouter la facture
            </button>
            <button class="btn btn-warning" @click="addCost()" v-else>
              <i class="bi bi-pencil"></i> Modifier la facture
            </button>
            <button
              class="btn btn-secondary ms-2"
              @click="cancelEditCost()"
              v-if="editingCostReference"
            >
              <i class="bi bi-x"></i> Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <vue-data-table
      :headers="headers"
      :data="consignmentCosts"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :show-filter="false"
    >
      <template #cell-cost_reference="{ row }">
        {{ row.costFullName || row.cost_reference }}
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTVA="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTVA > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTVA }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>
    </vue-data-table>
    <br />

    <!-- Consignment Items Section -->
    <div class="card mb-3" id="bloc-facture-fournisseur-dum">
      <div class="card-header">
        <h5 class="mb-0">Ajouter une facture fournisseur / DUM au dossier d'importation</h5>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-xl-2 col-12">
            <label for="">Article <span class="text-danger">*</span></label>
            <vue-select
              :options="items"
              v-model="selectedItem.item_reference"
              placeholder="Sélectionner un article"
              labelColumn="fullName"
              valueColumn="reference"
            />
            <small v-if="selectedItem.item_measuring" class="text-primary fw-semibold mt-1 d-block">
              <i class="bi bi-rulers"></i> Unité : {{ selectedItem.item_measuring }}
              <span v-if="selectedItem.item_pcs > 0"> — {{ selectedItem.item_pcs }} PCS / {{ selectedItem.item_measuring }}</span>
            </small>
          </div>

          <div class="col-xl-auto col-12 d-flex align-items-end">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="showNewItemForm = !showNewItemForm"
            >
              <i :class="showNewItemForm ? 'bi bi-x-circle' : 'bi bi-plus-circle'"></i>
              {{ showNewItemForm ? 'Annuler' : 'Nouvel article' }}
            </button>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Devise </label>
            <select v-model="selectedItem.currency" class="form-control">
              <option value="MAD">MAD</option>
              <option value="EURO">EURO</option>
              <option value="USD">USD</option>
            </select>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Taux de change </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.exchange_rate"
              class="form-control"
              placeholder="1.00"
            />
          </div>

          <div
            class="col-xl-2 col-12"
            v-if="selectedItem.currency !== 'MAD' || editingItemId"
          >
            <label for=""
              >Montant total HT en {{ selectedItem.currency }}
            </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.amount_currency"
              class="form-control"
              :placeholder="`Total HT en ${selectedItem.currency}`"
            />
            <small
              class="text-success fw-bold"
              v-if="selectedItem.amount_currency"
            >
              =
              {{
                (
                  parseFloat(selectedItem.amount_currency) *
                  parseFloat(selectedItem.exchange_rate || 1)
                ).toFixed(2)
              }}
              MAD (Total HT)
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Prix unitaire HT (MAD) </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.priceHT"
              class="form-control"
              placeholder="Prix unitaire HT en MAD"
              readonly
            />
            <small class="text-muted" v-if="selectedItem.priceHT">
              = Total HT / Quantité
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Prix unitaire TTC (MAD) </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.priceTTC"
              class="form-control"
              placeholder="Prix unitaire TTC en MAD"
              readonly
            />
            <small class="text-muted" v-if="selectedItem.priceTTC">
              Calculé automatiquement
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">
              Quantité ({{ selectedItem.item_measuring || 'unité' }})
              <span class="text-danger">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.quantity"
              class="form-control"
              :placeholder="'Qté en ' + (selectedItem.item_measuring || 'unité')"
            />
            <small v-if="selectedItem.item_pcs > 0" class="text-muted">
              ← calculé depuis PCS ÷ {{ selectedItem.item_pcs }}
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Quantité (PCS)</label>
            <input
              type="number"
              step="1"
              v-model="selectedItem.quantity_pcs"
              class="form-control"
              placeholder="Qté en pièces"
            />
            <small v-if="selectedItem.item_pcs > 0" class="text-muted">
              1 {{ selectedItem.item_measuring }} = {{ selectedItem.item_pcs }} PCS
            </small>
          </div>
        </div>
        <div
          class="row mt-2"
          v-if="selectedItem.currency !== 'MAD' && selectedItem.amount_currency"
        >
          <div class="col-xl-12">
            <div class="alert alert-info">
              <strong>Conversion automatique:</strong>
              <span v-if="selectedItem.amount_currency">
                Montant HT: {{ selectedItem.amount_currency }}
                {{ selectedItem.currency }} × {{ selectedItem.exchange_rate }} =
                {{
                  (
                    parseFloat(selectedItem.amount_currency || 0) *
                    parseFloat(selectedItem.exchange_rate || 1)
                  ).toFixed(2)
                }}
                MAD
              </span>
              <span v-if="selectedItem.priceTTC"> | </span>
              <span v-if="selectedItem.priceTTC">
                Prix TTC: {{ parseFloat(selectedItem.priceTTC).toFixed(2) }} MAD
              </span>
            </div>
          </div>
        </div>
        <br />
        <div class="row align-items-end">
          <div class="col-xl-3 col-12">
            <label for="">Marge bénéficiaire %</label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.profit_margin"
              class="form-control"
              placeholder="7.00"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Remarque </label>
            <input
              type="text"
              v-model="selectedItem.remark"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="dum-file-input">
              Fichier DUM / facture fournisseur
              <span class="badge bg-light text-primary border ms-1" style="font-size:0.7em;">
                <i class="bi bi-stars"></i> IA PDF/Image/Excel/Word
              </span>
            </label>
            <input
              id="dum-file-input"
              type="file"
              ref="dumFileInput"
              class="form-control"
              accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx"
              style="display: none"
              @change="handleDumFileChange"
            />
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="triggerDumFileInput"
                :disabled="isAnalyzingDumAI"
              >
                <i class="bi bi-upload"></i>
                {{
                  selectedItem.dum_file
                    ? "Fichier sélectionné"
                    : "Importer un fichier"
                }}
              </button>
              <button
                v-if="selectedItem.dum_file && !isAnalyzingDumAI"
                type="button"
                class="btn btn-outline-danger btn-sm"
                @click="removeDumFile"
              >
                <i class="bi bi-x"></i>
              </button>
              <span v-if="isAnalyzingDumAI" class="d-flex align-items-center text-primary gap-1">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <small>Analyse IA en cours...</small>
              </span>
            </div>
            <small v-if="selectedItem.dum_file && !isAnalyzingDumAI" class="text-muted d-block mt-1">
              <i class="bi bi-paperclip"></i> {{ selectedItem.dum_file.name }}
            </small>
            <small v-if="!selectedItem.dum_file && !isAnalyzingDumAI && !selectedItem.dum_existing_path" class="text-muted d-block mt-1">
              PDF, JPG ou PNG — le formulaire sera rempli automatiquement
            </small>
            <small
              v-else-if="selectedItem.dum_existing_path && !selectedItem.dum_file"
              class="text-success d-block mt-1"
            >
              Document déjà enregistré — importez un nouveau fichier pour le remplacer.
            </small>
            <small v-if="dumAiAnalysisError" class="text-warning d-block mt-1">
              <i class="bi bi-exclamation-triangle"></i> {{ dumAiAnalysisError }}
            </small>
          </div>

          <div class="col-xl-auto col">
            <label for=""></label>
            <button
              class="btn btn-success"
              @click="addItem()"
              v-if="!editingItemId"
            >
              <i class="bi bi-plus-circle"></i> Ajouter l'article
            </button>
            <button class="btn btn-warning" @click="addItem()" v-else>
              <i class="bi bi-pencil"></i> Modifier l'article
            </button>
            <button
              class="btn btn-secondary ms-2"
              @click="cancelEditItem()"
              v-if="editingItemId"
            >
              <i class="bi bi-x"></i> Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Inline new item creation form -->
    <div class="card mb-3 border-secondary" v-if="showNewItemForm">
      <div class="card-header bg-secondary text-white py-2">
        <h6 class="mb-0">
          <i class="bi bi-plus-circle me-1"></i> Créer un nouvel article
        </h6>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-xl-4 col-12">
            <label>Désignation <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="newItem.fullName"
              class="form-control"
              placeholder="Nom de l'article"
              autofocus
            />
          </div>
          
          <div class="col-xl-2 col-12">
            <label>Unité</label>
            <select v-model="newItem.measuring" class="form-control">
              <option value="">-- Sélectionner --</option>
              <option value="M3">M3</option>
              <option value="M2">M2</option>
              <option value="Qx">Qx</option>
              <option value="Kg">Kg</option>
              <option value="PCS">PCS</option>
              <option value="M">M</option>
            </select>
          </div>
          <div class="col-xl-2 col-12">
            <label>{{ newItem.measuring || "Unité" }} (total)</label>
            <input
              type="number"
              step="any"
              min="0"
              v-model="newItem.equivalenceMeasure"
              class="form-control"
              :placeholder="`Ex: 3 ${newItem.measuring || ''}`"
              :disabled="!newItem.measuring"
              @input="syncNewItemPcsFromEquivalence"
            />
          </div>
          <div class="col-xl-2 col-12">
            <label>PCS (total)</label>
            <input
              type="number"
              step="any"
              min="0"
              v-model="newItem.equivalencePcs"
              class="form-control"
              placeholder="Ex: 2000"
              @input="syncNewItemPcsFromEquivalence"
            />
          </div>
          <div class="col-xl-2 col-12">
            <label>Pièces par {{ newItem.measuring || "unité" }}</label>
            <input
              type="number"
              step="any"
              min="0"
              v-model="newItem.pcs"
              class="form-control"
              placeholder="Calculé (modifiable)"
            />
            <small class="text-muted" v-if="newItem.equivalencePcs && newItem.equivalenceMeasure && newItem.measuring">
              {{ newItem.equivalencePcs }} PCS = {{ newItem.equivalenceMeasure }} {{ newItem.measuring }}
            </small>
          </div>
          <div class="col-xl-auto col-12">
            <button
              class="btn btn-success"
              @click="createNewItem()"
              :disabled="!newItem.fullName"
            >
              <i class="bi bi-check2"></i> Créer et sélectionner
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Apply global exchange rate to all items -->
    <div class="card mb-3 border-warning" v-if="consignmentItems && consignmentItems.length > 0">
      <div class="card-body py-2">
        <div class="row align-items-center">
          <div class="col-auto">
            <label class="mb-0 fw-semibold text-warning">
              <i class="bi bi-currency-exchange"></i> Appliquer un taux de change à tous les articles
            </label>
          </div>
          <div class="col-xl-2 col-12">
            <input
              type="number"
              step="0.0001"
              min="0.0001"
              v-model="globalExchangeRate"
              class="form-control form-control-sm"
              placeholder="Ex: 10.85"
            />
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-warning btn-sm"
              @click="applyExchangeRateToAll"
              :disabled="isApplyingExchangeRate || !globalExchangeRate || parseFloat(globalExchangeRate) <= 0"
            >
              <span v-if="isApplyingExchangeRate" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-arrow-repeat me-1"></i>
              {{ isApplyingExchangeRate ? 'Recalcul en cours...' : 'Appliquer à tous' }}
            </button>
          </div>
          <div class="col-auto text-muted small">
            Recalcule <strong>Prix HT</strong>, <strong>Prix TTC</strong>, <strong>Total HT</strong> et <strong>Total TTC</strong> pour tous les articles affichés.
          </div>
        </div>
      </div>
    </div>

    <vue-data-table
      ref="itemsTable"
      :headers="itemHeaders"
      :data="consignmentItems"
      :items-per-page="10"
      :buttons="itemButtons"
      :summable-columns="itemSummableColumns"
      :show-filter="false"
    >
      <template #cell-item_reference="{ row }">
        {{ row.itemFullName || row.item_reference }}
      </template>

      <template #cell-priceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.priceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.priceHT }}
        </span>
      </template>

      <template #cell-priceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.priceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.priceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #footer-totalPriceHT="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

      <template #cell-quantity_pcs="{ row }">
        <span v-if="row.quantity_pcs != null" class="fw-bold">
          {{ row.quantity_pcs }}
        </span>
        <span v-else class="text-muted">—</span>
      </template>
    </vue-data-table>
    <br />

    <!-- Calculation Summary Card (if multiple items) -->
    <div
      class="card mb-3"
      v-if="
        consignmentItemsCount > 1 &&
        (consignmentCosts.length > 0 || consignmentItems.length > 0)
      "
    >
      <div class="card-header bg-info text-white">
        <h5 class="mb-0">Calcul de la facture par article (factures uniquement)</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <strong>Total des factures HT (sans articles):</strong>
            <span class="ms-2 text-primary fw-bold">
              {{ totalCostsOnlyHT.toFixed(2) }} MAD
            </span>
          </div>
          <div class="col-md-6">
            <strong>Nombre d'articles:</strong>
            <span class="ms-2 text-primary fw-bold">
              {{ consignmentItemsCount }}
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <strong>Facture par article (Total factures / Nombre d'articles):</strong>
            <span class="ms-2 text-warning fw-bold fs-5">
              {{ costPerItemFromCosts.toFixed(2) }} MAD
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 col-12">
        <label for="">Société <span class="text-danger">*</span> </label>

        <vue-select
          :options="societies"
          v-model="consignment.society_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Numéro</label>
        <input
          type="text"
          v-model.trim="consignment.number"
          class="form-control"
          placeholder="N°"
          autocomplete="off"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Fournisseur</label>
        <vue-select
          :options="suppliers"
          v-model="consignment.supplier_reference"
          placeholder="Optionnel"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Date<span class="text-danger">*</span></label>
        <input type="date" v-model="consignment.date" class="form-control" />
      </div>

      <!-- <div class="col-xl-3 col-12">
        <label for="">Taux de change<span class="text-danger">*</span></label>
        <input
          type="number"
          step="0.01"
          v-model="consignment.exchange_rate"
          class="form-control"
        />
      </div> -->
    </div>
    <!-- <br />
    <div class="row">
      <div class="col-xl-3 col-12">
        <label for="">Marge bénéficiaire %</label>
        <input
          type="number"
          step="0.01"
          v-model="consignment.profit_margin"
          class="form-control"
          placeholder="7.00"
        />
      </div>
    </div> -->
    <br />
    <div class="row">
      <div class="col-xl-12 col-12">
        <label for=""> Remarque </label>
        <textarea v-model="consignment.remark" class="form-control"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="save(consignment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constant from "../../constant";

export default {
  data() {
    return {
      consignment: {
        society_reference: null,
        supplier_reference: null,
        number: "",
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        exchange_rate: 1,
        profit_margin: 7.0,
        remark: "",
      },
      accept: false,
      actionButtons: [
        {
          label: "Modifier les factures",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.$router.push({ name: "consignment-costs-create" }),
        },
        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: () => this.refresh(),
        },
      ],

      headers: [
        { field: "cost_reference", label: "Facture", class: "" },
        {
          field: "totalPriceTTC",
          label: "Total TTC",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceHT",
          label: "Total HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceTVA",
          label: "Total TVA",
          class: "fw-bold",
          isAmount: true,
        },
        { field: "tva", label: "TVA %", class: "" },
        { field: "paymentMethod", label: "Méthode de paiement", class: "" },
        { field: "paymentDate", label: "Date de paiement", class: "" },
        { field: "userFullName", label: "Créer par", class: "" },
      ],
      selectedCost: {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      },
      editingCostReference: null, // Track which cost we're editing
      isCalculating: false, // Flag to prevent infinite loops during calculations
      isAnalyzingAI: false, // Flag for Groq AI analysis in progress
      aiAnalysisError: null, // Error message from AI analysis
      isAnalyzingDumAI: false, // Flag for DUM/item AI analysis in progress
      dumAiAnalysisError: null, // Error message from DUM AI analysis
      globalExchangeRate: null, // Global exchange rate to apply to all items
      isApplyingExchangeRate: false, // Flag for bulk exchange rate update
      // Button actions
      buttons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (item) => {
            this.editCost(item);
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (item) => {
            this.deleteCost(item);
          },
        },
      ],
      // Columns to summarize
      summableColumns: [
        { field: "totalPriceTTC", class: "fw-bold" },
        { field: "totalPriceHT", class: "fw-bold" },
        { field: "totalPriceTVA", class: "fw-bold" },
      ],
      // Items section
      itemHeaders: [
        { field: "item_reference", label: "Article", class: "" },
        { field: "currency", label: "Devise", class: "" },
        {
          field: "exchange_rate",
          label: "Taux de change",
          class: "",
          isAmount: true,
        },
        {
          field: "amount_currency",
          label: "Montant HT (Devise)",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "priceHT",
          label: "Prix HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "priceTTC",
          label: "Prix TTC",
          class: "fw-bold",
          isAmount: true,
        },
        { field: "quantity", label: "Quantité", class: "fw-bold" },
        { field: "quantity_pcs", label: "Qté (PCS)", class: "fw-bold" },
        {
          field: "totalPriceHT",
          label: "Total HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceTTC",
          label: "Total TTC",
          class: "fw-bold",
          isAmount: true,
        },
        { field: "remark", label: "Remarque", class: "" },
        { field: "userFullName", label: "Créé par", class: "" },
      ],
      selectedItem: {
        item_reference: "",
        currency: "MAD",
        exchange_rate: 1,
        amount_currency: "",
        priceHT: "",
        priceTTC: "",
        quantity: "",
        quantity_pcs: "",
        item_pcs: "",
        item_measuring: "",
        profit_margin: 7.0,
        remark: "",
        dum_file: null,
        dum_existing_path: "",
      },
      isCalculatingQty: false,
      editingItemId: null, // Track which item we're editing
      showNewItemForm: false,
      newItem: {
        fullName: "",
        priceTTC: "",
        measuring: "",
        equivalenceMeasure: "",
        equivalencePcs: "",
        pcs: "",
      },
      itemButtons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (item) => {
            this.editItem(item);
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      itemSummableColumns: [
        { field: "totalPriceHT", class: "fw-bold" },
        { field: "totalPriceTTC", class: "fw-bold" },
        { field: "quantity", class: "fw-bold" },
      ],
    };
  },
  computed: {
    ...mapGetters("consignment", {
      consignmentCosts: "getCosts",
      consignmentItems: "getItems",
    }),
    ...mapGetters("society", {
      societies: "getAll",
    }),
    ...mapGetters("cost", {
      costs: "getAll",
    }),
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    // Count of consignment items
    consignmentItemsCount() {
      if (!this.consignmentItems || this.consignmentItems.length === 0)
        return 0;
      return this.consignmentItems.length;
    },
    // Total costs HT (without items) - sum of all consignment_costs only
    totalCostsOnlyHT() {
      if (!this.consignmentCosts || this.consignmentCosts.length === 0)
        return 0;
      return this.consignmentCosts.reduce(
        (sum, cost) => sum + parseFloat(cost.totalPriceHT || 0),
        0
      );
    },
    // Cost per item from costs only (if multiple items)
    costPerItemFromCosts() {
      if (this.consignmentItemsCount <= 1) return 0;
      if (this.consignmentItemsCount === 0) return 0;
      return this.totalCostsOnlyHT / this.consignmentItemsCount;
    },
  },
  methods: {
    async save(data) {
      // Validate required fields
      if (!data.society_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une société.",
        });
        return;
      }

      if (!data.date) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une date.",
        });
        return;
      }

      if (!data.exchange_rate || data.exchange_rate <= 0) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Le taux de change doit être supérieur à 0.",
        });
        return;
      }

      // Save the consignment (costs and items are automatically linked in the backend)
      const response = await this.$store.dispatch("consignment/store", data);

      // Navigate to consignments listing
      if (response && response.reference) {
        this.$router.push({ name: "consignments-index" });
      }
    },
    async refresh() {
      this.$store.dispatch("consignment/getAllCosts");
      this.$store.dispatch("consignment/getAllItems");
    },
    async editCost(item) {
      // Populate form with cost data
      this.editingCostReference = item.reference;
      this.selectedCost = {
        cost_reference: item.cost_reference || "",
        totalPriceTTC: item.totalPriceTTC || "",
        totalPriceHT: item.totalPriceHT || "",
        totalPriceTVA: item.totalPriceTVA || "",
        tva: item.tva || "",
        paymentMethod: item.paymentMethod || "",
        paymentDate: item.paymentDate || "",
        cheque_number: item.cheque_number || "",
        virement_number: item.virement_number || "",
        virementDate: item.virementDate || "",
        transfer_number: item.transfer_number || "",
        transferDate: item.transferDate || "",
        invoice_number: item.invoice_number || "",
        supplier_reference: item.supplier_reference || "",
        invoice_file: null, // File can't be pre-filled
        remark: item.remark || "",
      };
      // Scroll to form
      this.$nextTick(() => {
        const formElement = document.querySelector(".card.mb-3");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    cancelEditCost() {
      this.editingCostReference = null;
      this.selectedCost = {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      };
    },
    async deleteCost(item) {
      await this.$store.dispatch("consignment/destroyCost", item.reference);
    },
    async addCost() {
      if (!this.selectedCost.cost_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une facture.",
        });
        return;
      }

      // Check if we're editing or creating
      if (this.editingCostReference) {
        // Update existing cost
        const updateData = {
          reference: this.editingCostReference,
          cost_reference: this.selectedCost.cost_reference,
        };

        if (this.selectedCost.totalPriceTTC)
          updateData.totalPriceTTC = this.selectedCost.totalPriceTTC;
        if (this.selectedCost.totalPriceHT)
          updateData.totalPriceHT = this.selectedCost.totalPriceHT;
        if (this.selectedCost.totalPriceTVA)
          updateData.totalPriceTVA = this.selectedCost.totalPriceTVA;
        if (this.selectedCost.tva) updateData.tva = this.selectedCost.tva;
        if (this.selectedCost.paymentMethod)
          updateData.paymentMethod = this.selectedCost.paymentMethod;
        if (this.selectedCost.paymentDate)
          updateData.paymentDate = this.selectedCost.paymentDate;
        if (this.selectedCost.cheque_number)
          updateData.cheque_number = this.selectedCost.cheque_number;
        if (this.selectedCost.virement_number)
          updateData.virement_number = this.selectedCost.virement_number;
        if (this.selectedCost.virementDate)
          updateData.virementDate = this.selectedCost.virementDate;
        if (this.selectedCost.transfer_number)
          updateData.transfer_number = this.selectedCost.transfer_number;
        if (this.selectedCost.transferDate)
          updateData.transferDate = this.selectedCost.transferDate;
        if (this.selectedCost.invoice_number)
          updateData.invoice_number = this.selectedCost.invoice_number;
        if (this.selectedCost.supplier_reference)
          updateData.supplier_reference = this.selectedCost.supplier_reference;
        if (this.selectedCost.remark)
          updateData.remark = this.selectedCost.remark;

        await this.$store.dispatch("consignment/updateCost", updateData);
        this.editingCostReference = null;
      } else {
        // Create new cost
        const formData = new FormData();

        // Append all cost data
        formData.append("cost_reference", this.selectedCost.cost_reference);
        if (this.selectedCost.totalPriceTTC)
          formData.append("totalPriceTTC", this.selectedCost.totalPriceTTC);
        if (this.selectedCost.totalPriceHT)
          formData.append("totalPriceHT", this.selectedCost.totalPriceHT);
        if (this.selectedCost.totalPriceTVA)
          formData.append("totalPriceTVA", this.selectedCost.totalPriceTVA);
        if (this.selectedCost.tva)
          formData.append("tva", this.selectedCost.tva);
        if (this.selectedCost.paymentMethod)
          formData.append("paymentMethod", this.selectedCost.paymentMethod);
        if (this.selectedCost.paymentDate)
          formData.append("paymentDate", this.selectedCost.paymentDate);
        if (this.selectedCost.cheque_number)
          formData.append("cheque_number", this.selectedCost.cheque_number);
        if (this.selectedCost.virement_number)
          formData.append("virement_number", this.selectedCost.virement_number);
        if (this.selectedCost.virementDate)
          formData.append("virementDate", this.selectedCost.virementDate);
        if (this.selectedCost.transfer_number)
          formData.append("transfer_number", this.selectedCost.transfer_number);
        if (this.selectedCost.transferDate)
          formData.append("transferDate", this.selectedCost.transferDate);
        if (this.selectedCost.invoice_number)
          formData.append("invoice_number", this.selectedCost.invoice_number);
        if (this.selectedCost.supplier_reference)
          formData.append(
            "supplier_reference",
            this.selectedCost.supplier_reference
          );
        if (this.selectedCost.remark)
          formData.append("remark", this.selectedCost.remark);

        // Append invoice file if selected
        if (this.selectedCost.invoice_file) {
          formData.append("invoice_file", this.selectedCost.invoice_file);
        }

        // Store cost temporarily (without consignment_reference yet)
        // The consignment_reference will be set when the consignment is saved
        await this.$store.dispatch("consignment/storeCost", formData);
      }

      // Reset the form
      this.selectedCost = {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      };
    },
    triggerInvoiceFileInput() {
      this.$refs.invoiceFileInput.click();
    },
    handleInvoiceFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedCost.invoice_file = file;
        this.aiAnalysisError = null;
        // Trigger AI analysis for images and PDFs
        if (file.type.startsWith('image/') || file.type === 'application/pdf') {
          this.analyzeInvoiceWithAI(file);
        }
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    // Loads pdf.js from CDN once and caches it on window
    async loadPdfJs() {
      if (window.pdfjsLib) return window.pdfjsLib;
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
        script.onload = () => {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
          resolve(window.pdfjsLib);
        };
        script.onerror = () => reject(new Error('Impossible de charger pdf.js'));
        document.head.appendChild(script);
      });
    },
    // Renders first page of a PDF file to a base64 image string (used for cost invoices)
    async pdfFileToBase64Image(file) {
      const pages = await this.pdfToAllPagesBase64(file, 1);
      return pages[0];
    },
    // Renders ALL pages of a PDF (up to maxPages) — returns array of base64 strings
    async pdfToAllPagesBase64(file, maxPages = 20) {
      const pdfjsLib = await this.loadPdfJs();
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const total = Math.min(pdf.numPages, maxPages);
      const result = [];
      for (let i = 1; i <= total; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 2.0 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');
        await page.render({ canvasContext: ctx, viewport }).promise;
        result.push(canvas.toDataURL('image/jpeg', 0.85));
      }
      return result;
    },
    async analyzeInvoiceWithAI(file) {
      this.isAnalyzingAI = true;
      this.aiAnalysisError = null;
      try {
        let base64;
        if (file.type === 'application/pdf') {
          base64 = await this.pdfFileToBase64Image(file);
        } else {
          base64 = await this.fileToBase64(file);
        }
        // Read Groq API key from settings (fallback to default)
        const apiKey = this.$setting('groq_api_key') || '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';
        const prompt = `Analyse cette image de facture et extrais les informations suivantes sous forme d'objet JSON uniquement (sans explication ni markdown, juste le JSON brut) :
{
  "totalPriceTTC": <montant total TTC (nombre) ou null>,
  "totalPriceHT": <montant hors taxe (nombre) ou null>,
  "totalPriceTVA": <montant de la TVA (nombre) ou null>,
  "tva": <taux de TVA en pourcentage ex: 20 (nombre) ou null>,
  "invoice_number": "<numéro de facture ou chaîne vide>",
  "paymentDate": "<date au format YYYY-MM-DD ou chaîne vide>",
  "paymentMethod": "<cash ou cheque ou virement ou transfer ou chaîne vide>",
  "remark": "<remarque contextuelle ou chaîne vide>",
  "supplier_name": "<nom complet du fournisseur/vendeur émetteur de la facture ou chaîne vide>",
  "cost_name": "<type ou catégorie du coût ex: Transport, Douane, Transitaire, Assurance, Frais bancaires ou chaîne vide>"
}
Si un champ n'est pas visible dans la facture, utilise null pour les nombres et une chaîne vide pour les chaînes.`;
        const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            model: 'meta-llama/llama-4-scout-17b-16e-instruct',
            messages: [
              {
                role: 'user',
                content: [
                  { type: 'text', text: prompt },
                  { type: 'image_url', image_url: { url: base64 } },
                ],
              },
            ],
            max_tokens: 512,
            temperature: 0.1,
          }),
        });
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error && errData.error.message ? errData.error.message : `Erreur API Groq (${response.status})`);
        }
        const data = await response.json();
        const content = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
        if (!content) throw new Error('Réponse vide de l\'IA');
        // Strip markdown fences if present
        const jsonStr = content.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
        let extracted;
        try {
          extracted = JSON.parse(jsonStr);
        } catch (e) {
          throw new Error('Impossible de parser la réponse JSON de l\'IA');
        }
        // Fill basic form fields with extracted values (manual edits override AI values)
        if (extracted.totalPriceTTC != null) this.selectedCost.totalPriceTTC = extracted.totalPriceTTC;
        if (extracted.totalPriceHT != null) this.selectedCost.totalPriceHT = extracted.totalPriceHT;
        if (extracted.totalPriceTVA != null) this.selectedCost.totalPriceTVA = extracted.totalPriceTVA;
        if (extracted.tva != null) this.selectedCost.tva = extracted.tva;
        if (extracted.invoice_number) this.selectedCost.invoice_number = extracted.invoice_number;
        if (extracted.paymentDate) this.selectedCost.paymentDate = extracted.paymentDate;
        if (extracted.paymentMethod) this.selectedCost.paymentMethod = extracted.paymentMethod;
        if (extracted.remark) this.selectedCost.remark = extracted.remark;

        const autoCreated = [];

        // Auto-create supplier if AI extracted a name and it doesn't exist
        if (extracted.supplier_name) {
          const supplierName = extracted.supplier_name.trim().toUpperCase();
          const existingSupplier = this.suppliers.find(
            (s) => s.fullName && s.fullName.toUpperCase() === supplierName
          );
          if (existingSupplier) {
            this.selectedCost.supplier_reference = existingSupplier.reference;
          } else {
            try {
              const res = await this.$api.instance.post('suppliers', { society: supplierName });
              const newSupplier = res.data && (res.data.data || res.data);
              if (newSupplier && newSupplier.reference) {
                await this.$store.dispatch('supplier/getAll');
                await this.$nextTick();
                this.selectedCost.supplier_reference = newSupplier.reference;
                autoCreated.push(`Fournisseur "${supplierName}" créé`);
              }
            } catch (e) {
              console.warn('Auto-create supplier failed:', e);
            }
          }
        }

        // Auto-create cost type if AI extracted a name and it doesn't exist
        if (extracted.cost_name) {
          const costName = extracted.cost_name.trim().toUpperCase();
          const existingCost = this.costs.find(
            (c) => c.fullName && c.fullName.toUpperCase() === costName
          );
          if (existingCost) {
            this.selectedCost.cost_reference = existingCost.reference;
          } else {
            try {
              const res = await this.$api.instance.post('costs', { fullName: costName, tva: extracted.tva || 0, is_importation: true });
              const newCost = res.data && (res.data.data || res.data);
              if (newCost && newCost.reference) {
                await this.$store.dispatch('cost/getAll');
                await this.$nextTick();
                this.selectedCost.cost_reference = newCost.reference;
                autoCreated.push(`Coût "${costName}" créé`);
              }
            } catch (e) {
              console.warn('Auto-create cost failed:', e);
            }
          }
        }

        const extra = autoCreated.length ? ` (${autoCreated.join(', ')})` : '';
        await this.$store.dispatch('notification/store', {
          status: 'success',
          message: `Formulaire rempli automatiquement par l'IA Groq.${extra}`,
        });
      } catch (error) {
        console.error('Groq AI analysis error:', error);
        this.aiAnalysisError = error.message || 'Analyse IA échouée';
        await this.$store.dispatch('notification/store', {
          status: 'warning',
          message: 'Analyse IA échouée : ' + (error.message || 'erreur inconnue'),
        });
      } finally {
        this.isAnalyzingAI = false;
      }
    },
    removeInvoiceFile() {
      this.selectedCost.invoice_file = null;
      this.aiAnalysisError = null;
      if (this.$refs.invoiceFileInput) {
        this.$refs.invoiceFileInput.value = "";
      }
    },
    triggerDumFileInput() {
      if (this.$refs.dumFileInput) {
        this.$refs.dumFileInput.click();
      }
    },
    handleDumFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      this.selectedItem.dum_file = file;
      this.dumAiAnalysisError = null;
      const officeTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
      if (file.type.startsWith('image/') || file.type === 'application/pdf') {
        this.analyzeItemWithAI(file);
      } else if (officeTypes.includes(file.type) || /\.(xls|xlsx|doc|docx)$/i.test(file.name)) {
        this.analyzeItemWithAILocalChat(file);
      }
    },
    async analyzeItemWithAI(file) {
      this.isAnalyzingDumAI = true;
      this.dumAiAnalysisError = null;
      try {
        // Build list of page images — all pages for PDF, single image otherwise
        let images = [];
        if (file.type === 'application/pdf') {
          images = await this.pdfToAllPagesBase64(file, 20);
        } else {
          images = [await this.fileToBase64(file)];
        }

        const apiKey = this.$setting('groq_api_key') || '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';

        const prompt = `Tu reçois une ou plusieurs pages d'une facture fournisseur.
Extrais TOUTES les lignes de produits/marchandises présentes dans ces pages et retourne un tableau JSON uniquement (sans explication ni markdown, juste le tableau JSON brut).
Chaque élément du tableau doit avoir cette structure :
{
  "item_name": "<désignation exacte de l'article tel qu'il apparaît sur la facture, ou chaîne vide>",
  "measuring": "<unité de mesure parmi : M3, M2, Qx, Kg, PCS, M — ou chaîne vide>",
  "currency": "<devise : MAD, EURO ou USD — MAD si non précisée>",
  "exchange_rate": <taux de change numérique, 1 par défaut>,
  "amount_currency": <montant total HT de la ligne dans la devise (nombre) ou null>,
  "quantity": <quantité de la ligne (nombre) ou null>,
  "quantity_pcs": <quantité en pièces si précisée (nombre) ou null>,
  "remark": "<description complémentaire ou chaîne vide>"
}
Règles :
- Une ligne par article distinct — ne regroupe pas plusieurs articles.
- Si la facture ne contient qu'un seul article, retourne un tableau avec un seul élément.
- Ignore les lignes de totaux, taxes, frais, remises — uniquement les lignes produits.
- Si un champ est introuvable, utilise null pour les nombres et chaîne vide pour les chaînes.`;

        // Build content: prompt text + all page images
        const contentParts = [{ type: 'text', text: prompt }];
        for (const img of images) {
          contentParts.push({ type: 'image_url', image_url: { url: img } });
        }

        const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            model: 'meta-llama/llama-4-scout-17b-16e-instruct',
            messages: [{ role: 'user', content: contentParts }],
            max_tokens: 2048,
            temperature: 0.1,
          }),
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error && errData.error.message ? errData.error.message : `Erreur API Groq (${response.status})`);
        }
        const data = await response.json();
        const content = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
        if (!content) throw new Error('Réponse vide de l\'IA');

        const _parsedImg = this._extractJsonArray(content);
        if (!_parsedImg) throw new Error('Impossible de parser la réponse JSON de l\'IA');
        const extractedList = Array.isArray(_parsedImg) ? _parsedImg : [_parsedImg];
        if (extractedList.length === 0) {
          throw new Error('Aucun article trouvé dans la facture');
        }

        let addedCount = 0;
        let skippedCount = 0;

        for (const extracted of extractedList) {
          // Reset form for each item
          this.selectedItem = {
            item_reference: '',
            currency: extracted.currency && ['MAD', 'EURO', 'USD'].includes(extracted.currency) ? extracted.currency : 'MAD',
            exchange_rate: extracted.exchange_rate != null ? extracted.exchange_rate : 1,
            amount_currency: '',
            priceHT: '',
            priceTTC: '',
            quantity: extracted.quantity != null ? extracted.quantity : '',
            quantity_pcs: extracted.quantity_pcs != null ? extracted.quantity_pcs : '',
            item_pcs: '',
            item_measuring: '',
            profit_margin: 7.0,
            remark: extracted.remark || '',
            dum_file: this.selectedItem.dum_file, // keep the file reference
            dum_existing_path: '',
          };

          // Find or create item in DB
          if (extracted.item_name) {
            const itemName = extracted.item_name.trim().toUpperCase();
            const existingItem = this.items.find(
              (i) => i.fullName && i.fullName.toUpperCase() === itemName
            );
            if (existingItem) {
              this.selectedItem.item_reference = existingItem.reference;
            } else {
              try {
                const res = await this.$api.instance.post('items', {
                  fullName: itemName,
                  measuring: extracted.measuring || '',
                });
                const newRef = res.data && (typeof res.data.data === 'string' ? res.data.data : null);
                if (newRef) {
                  await this.$store.dispatch('item/getAll');
                  await this.$nextTick();
                  this.selectedItem.item_reference = newRef;
                }
              } catch (e) {
                console.warn('Auto-create item failed:', e);
              }
            }
          }

          // Set amount_currency last — triggers watcher → calculateItemAmounts
          if (extracted.amount_currency != null) {
            await this.$nextTick();
            this.selectedItem.amount_currency = extracted.amount_currency;
          }

          // Auto-save if required fields are present
          const canSave =
            this.selectedItem.item_reference &&
            parseFloat(this.selectedItem.quantity) > 0 &&
            this.selectedItem.amount_currency;

          if (canSave) {
            await this.$nextTick();
            await this.addItem();
            addedCount++;
          } else {
            skippedCount++;
          }
        }

        const msg = addedCount > 0
          ? `${addedCount} article(s) ajouté(s) automatiquement depuis la facture fournisseur.`
            + (skippedCount > 0 ? ` ${skippedCount} ligne(s) ignorée(s) (données incomplètes).` : '')
          : 'Formulaire rempli par l\'IA — vérifiez les champs manquants puis cliquez sur Ajouter.';

        await this.$store.dispatch('notification/store', { status: 'success', message: msg });
      } catch (error) {
        console.error('Groq DUM AI analysis error:', error);
        this.dumAiAnalysisError = error.message || 'Analyse IA échouée';
        await this.$store.dispatch('notification/store', {
          status: 'warning',
          message: 'Analyse IA échouée : ' + (error.message || 'erreur inconnue'),
        });
      } finally {
        this.isAnalyzingDumAI = false;
      }
    },
    // Robust JSON array extractor — handles responses with surrounding text / code fences
    _extractJsonArray(text) {
      if (!text) return null;
      // Strip all code fences
      let s = text.replace(/```[\w]*\n?/g, '').replace(/```/g, '');
      // 1. Try the whole cleaned string
      const trimmed = s.trim();
      if (trimmed.startsWith('[')) {
        try { return JSON.parse(trimmed); } catch (_) {}
      }
      // 2. Find the first '[' and last ']' in the original text
      const a = text.indexOf('[');
      const b = text.lastIndexOf(']');
      if (a !== -1 && b > a) {
        try { return JSON.parse(text.slice(a, b + 1)); } catch (_) {}
      }
      // 3. Single object → wrap in array
      const c = text.indexOf('{');
      const d = text.lastIndexOf('}');
      if (c !== -1 && d > c) {
        try { return [JSON.parse(text.slice(c, d + 1))]; } catch (_) {}
      }
      return null;
    },
    async analyzeItemWithAILocalChat(file) {
      this.isAnalyzingDumAI = true;
      this.dumAiAnalysisError = null;
      try {
        const prompt = `Le contenu ci-dessous provient d'une facture fournisseur (fichier Excel ou Word).
Extrais TOUTES les lignes de produits/marchandises et réponds UNIQUEMENT avec un tableau JSON brut.
NE PAS écrire d'explication, NE PAS écrire de code, NE PAS utiliser de markdown. Ta réponse doit commencer par [ et se terminer par ].
Structure de chaque élément :
{"item_name":"<désignation exacte>","measuring":"<M3|M2|Qx|Kg|PCS|M ou vide>","currency":"<MAD|EURO|USD>","exchange_rate":1,"amount_currency":<nombre ou null>,"quantity":<nombre ou null>,"quantity_pcs":<nombre ou null>,"remark":""}
Règles : une ligne par article, ignorer totaux/taxes/frais, null pour nombres manquants, chaîne vide pour textes manquants.`;

        // Read file as base64 DataURL (required by Laravel localchat controller)
        const fileData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload  = () => resolve(reader.result);
          reader.onerror = reject;
        });

        const response = await this.$api.instance.post('chatbot/localchat', {
          message:   prompt,
          file_data: fileData,
          file_name: file.name,
          mime_type: file.type || 'application/octet-stream',
        });

        const raw = response.data && (response.data.content || response.data.answer || '');
        if (!raw) throw new Error('Réponse vide de l\'IA LocalChat');

        const _parsed = this._extractJsonArray(raw);
        if (!_parsed) throw new Error('Impossible de parser la réponse JSON de l\'IA (aucun tableau JSON trouvé)');
        const extractedList = Array.isArray(_parsed) ? _parsed : [_parsed];
        if (extractedList.length === 0) throw new Error('Aucun article trouvé dans le fichier');

        let addedCount = 0;
        let skippedCount = 0;

        for (const extracted of extractedList) {
          this.selectedItem = {
            item_reference: '',
            currency: extracted.currency && ['MAD', 'EURO', 'USD'].includes(extracted.currency) ? extracted.currency : 'MAD',
            exchange_rate: extracted.exchange_rate != null ? extracted.exchange_rate : 1,
            amount_currency: '',
            priceHT: '',
            priceTTC: '',
            quantity: extracted.quantity != null ? extracted.quantity : '',
            quantity_pcs: extracted.quantity_pcs != null ? extracted.quantity_pcs : '',
            item_pcs: '',
            item_measuring: '',
            profit_margin: 7.0,
            remark: extracted.remark || '',
            dum_file: this.selectedItem.dum_file,
            dum_existing_path: '',
          };

          if (extracted.item_name) {
            const itemName = extracted.item_name.trim().toUpperCase();
            const existingItem = this.items.find(
              (i) => i.fullName && i.fullName.toUpperCase() === itemName
            );
            if (existingItem) {
              this.selectedItem.item_reference = existingItem.reference;
            } else {
              try {
                const res = await this.$api.instance.post('items', { fullName: itemName, measuring: extracted.measuring || '' });
                const newRef = res.data && (typeof res.data.data === 'string' ? res.data.data : null);
                if (newRef) {
                  await this.$store.dispatch('item/getAll');
                  await this.$nextTick();
                  this.selectedItem.item_reference = newRef;
                }
              } catch (e) {
                console.warn('Auto-create item failed:', e);
              }
            }
          }

          if (extracted.amount_currency != null) {
            await this.$nextTick();
            this.selectedItem.amount_currency = extracted.amount_currency;
          }

          const canSave =
            this.selectedItem.item_reference &&
            parseFloat(this.selectedItem.quantity) > 0 &&
            this.selectedItem.amount_currency;

          if (canSave) {
            await this.$nextTick();
            await this.addItem();
            addedCount++;
          } else {
            skippedCount++;
          }
        }

        const msg = addedCount > 0
          ? `${addedCount} article(s) ajouté(s) automatiquement depuis le fichier.`
            + (skippedCount > 0 ? ` ${skippedCount} ligne(s) ignorée(s) (données incomplètes).` : '')
          : 'Formulaire rempli par l\'IA — vérifiez les champs manquants puis cliquez sur Ajouter.';

        await this.$store.dispatch('notification/store', { status: 'success', message: msg });
      } catch (error) {
        console.error('LocalChat DUM AI analysis error:', error);
        this.dumAiAnalysisError = error.message || 'Analyse IA échouée';
        await this.$store.dispatch('notification/store', {
          status: 'warning',
          message: 'Analyse IA (LocalChat) échouée : ' + (error.message || 'erreur inconnue'),
        });
      } finally {
        this.isAnalyzingDumAI = false;
      }
    },
    async applyExchangeRateToAll() {
      const newRate = parseFloat(this.globalExchangeRate);
      if (!newRate || newRate <= 0) return;
      if (!this.consignmentItems || this.consignmentItems.length === 0) return;

      this.isApplyingExchangeRate = true;
      try {
        for (const item of this.consignmentItems) {
          const quantity   = parseFloat(item.quantity) || 1;
          const amountCurrency = parseFloat(item.amount_currency) || 0;

          // Recalculate HT in MAD using the new rate
          const totalHT = amountCurrency * newRate;
          const newPriceHT = totalHT / quantity;

          // Keep existing TVA ratio (priceTTC / priceHT) to recalculate TTC
          const oldPriceHT  = parseFloat(item.priceHT)  || 0;
          const oldPriceTTC = parseFloat(item.priceTTC) || 0;
          const tvaRatio = oldPriceHT > 0 ? oldPriceTTC / oldPriceHT : 1;
          const newPriceTTC = newPriceHT * tvaRatio;

          await this.$api.instance.put(
            `consignments_items/${item.id}`,
            {
              item_reference:   item.item_reference,
              currency:         item.currency,
              exchange_rate:    newRate,
              amount_currency:  amountCurrency,
              priceHT:          parseFloat(newPriceHT.toFixed(4)),
              priceTTC:         parseFloat(newPriceTTC.toFixed(4)),
              quantity:         quantity,
              profit_margin:    item.profit_margin,
              remark:           item.remark || '',
            }
          );
        }

        // Refresh table once after all updates
        await this.$store.dispatch('consignment/getAllItems');
        await this.$store.dispatch('notification/store', {
          status: 'success',
          message: `Taux de change ${newRate} appliqué à ${this.consignmentItems.length} article(s). Montants recalculés.`,
        });
      } catch (error) {
        console.error('applyExchangeRateToAll error:', error);
        await this.$store.dispatch('notification/store', {
          status: 'error',
          message: 'Erreur lors de la mise à jour des taux de change.',
        });
      } finally {
        this.isApplyingExchangeRate = false;
      }
    },
    removeDumFile() {
      this.selectedItem.dum_file = null;
      this.dumAiAnalysisError = null;
      if (this.$refs.dumFileInput) {
        this.$refs.dumFileInput.value = "";
      }
    },
    appendConsignmentItemFormData(formData, payload) {
      formData.append("item_reference", payload.item_reference);
      formData.append("currency", payload.currency);
      formData.append("exchange_rate", String(payload.exchange_rate));
      formData.append("amount_currency", String(payload.amount_currency));
      formData.append("priceHT", String(payload.priceHT));
      formData.append("priceTTC", String(payload.priceTTC));
      formData.append("quantity", String(payload.quantity));
      formData.append("totalPriceHT", String(payload.totalPriceHT));
      formData.append("totalPriceTTC", String(payload.totalPriceTTC));
      formData.append("profit_margin", String(payload.profit_margin));
      formData.append("remark", payload.remark || "");
      if (payload.dum_file) {
        formData.append("dum_file", payload.dum_file);
      }
    },
    async addItem() {
      if (!this.selectedItem.item_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner un article.",
        });
        return;
      }

      if (
        !this.selectedItem.quantity ||
        parseFloat(this.selectedItem.quantity) <= 0
      ) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "La quantité doit être supérieure à 0.",
        });
        return;
      }

      if (!this.selectedItem.amount_currency) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez entrer un montant en devise.",
        });
        return;
      }

      // Convert amount in currency to MAD for totals
      const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
      const currency = this.selectedItem.currency || "MAD";
      const quantity = parseFloat(this.selectedItem.quantity);

      // Convert total to MAD
      const totalPriceHT =
        currency === "MAD"
          ? parseFloat(this.selectedItem.amount_currency)
          : parseFloat(this.selectedItem.amount_currency) * exchangeRate;

      // Calculate totalPriceTTC based on item's TVA
      let totalPriceTTC = totalPriceHT;
      if (this.selectedItem.item_reference) {
        const item = this.items.find(
          (item) => item.reference === this.selectedItem.item_reference
        );
        if (item && item.tva !== null && item.tva !== undefined) {
          const tva = parseFloat(item.tva) || 0;
          if (tva > 0) {
            const totalTVA = totalPriceHT * (tva / 100);
            totalPriceTTC = totalPriceHT + totalTVA;
          }
        }
      }

      // Calculate unit prices = totals / quantity
      const priceHT = totalPriceHT / quantity;
      const priceTTC = totalPriceTTC / quantity;

      // Check if we're editing or creating
      try {
        const currency = this.selectedItem.currency || "MAD";
        const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
        // Use the amount_currency entered by the user
        const amount_currency_value =
          parseFloat(this.selectedItem.amount_currency) || 0;

        const profitMargin = parseFloat(this.selectedItem.profit_margin) || 7.0;
        const remark = this.selectedItem.remark || "";
        const hasDumFile = this.selectedItem.dum_file instanceof File;

        const jsonPayload = {
          item_reference: this.selectedItem.item_reference,
          currency: currency,
          exchange_rate: exchangeRate,
          amount_currency: amount_currency_value,
          priceHT: priceHT,
          priceTTC: priceTTC,
          quantity: quantity,
          quantity_pcs: parseFloat(this.selectedItem.quantity_pcs) || null,
          totalPriceHT: totalPriceHT,
          totalPriceTTC: totalPriceTTC,
          profit_margin: profitMargin,
          remark: remark,
        };

        if (this.editingItemId) {
          if (hasDumFile) {
            const formData = new FormData();
            this.appendConsignmentItemFormData(formData, {
              ...jsonPayload,
              dum_file: this.selectedItem.dum_file,
            });
            await this.$store.dispatch("consignment/updateItem", {
              id: this.editingItemId,
              formData,
            });
          } else {
            await this.$store.dispatch("consignment/updateItem", {
              id: this.editingItemId,
              ...jsonPayload,
            });
          }
          this.editingItemId = null;
        } else if (hasDumFile) {
          const formData = new FormData();
          this.appendConsignmentItemFormData(formData, {
            ...jsonPayload,
            dum_file: this.selectedItem.dum_file,
          });
          await this.$store.dispatch("consignment/storeItem", formData);
        } else {
          await this.$store.dispatch("consignment/storeItem", jsonPayload);
        }

        // Reset the form
        this.removeDumFile();
        this.selectedItem = {
          item_reference: "",
          currency: "MAD",
          exchange_rate: 1,
          amount_currency: "",
          priceHT: "",
          priceTTC: "",
          quantity: "",
          quantity_pcs: "",
          item_pcs: "",
          item_measuring: "",
          profit_margin: 7.0,
          remark: "",
          dum_file: null,
          dum_existing_path: "",
        };
      } catch (error) {
        console.error("Error adding/updating item:", error);
        await this.$store.dispatch("notification/store", {
          status: "error",
          message:
            "Erreur lors de l'ajout/modification de l'article: " +
            (error.message || "Erreur inconnue"),
        });
      }
    },
    async editItem(item) {
      this.removeDumFile();
      // Pre-fill the form with item data
      this.editingItemId = item.id;
      const currency = item.currency || "MAD";
      const exchangeRate = parseFloat(item.exchange_rate) || 1;
      const priceHT_MAD = parseFloat(item.priceHT) || 0;
      const priceTTC_MAD = parseFloat(item.priceTTC) || 0;
      const quantity = parseFloat(item.quantity) || 1;

      // Use stored amount_currency if available, otherwise calculate it
      let amount_currency = parseFloat(item.amount_currency);
      if (!amount_currency || isNaN(amount_currency)) {
        // Calculate from totalPriceHT if not stored
        const totalPriceHT = priceHT_MAD * quantity;
        amount_currency =
          currency === "MAD" ? totalPriceHT : totalPriceHT / exchangeRate;
      }

      const itemDetails = this.items.find((i) => i.reference === item.item_reference);
      const itemPcs = itemDetails && itemDetails.pcs ? parseFloat(itemDetails.pcs) : "";
      const itemMeasuring = itemDetails ? itemDetails.measuring || "" : "";

      this.selectedItem = {
        item_reference: item.item_reference,
        currency: currency,
        exchange_rate: exchangeRate,
        amount_currency: amount_currency.toFixed(2),
        priceHT: priceHT_MAD,
        priceTTC: priceTTC_MAD,
        quantity: item.quantity,
        quantity_pcs: itemPcs > 0 ? (quantity * itemPcs).toFixed(0) : "",
        item_pcs: itemPcs,
        item_measuring: itemMeasuring,
        profit_margin: parseFloat(item.profit_margin) || 7.0,
        remark: item.remark || "",
        dum_file: null,
        dum_existing_path: item.dum_file || "",
      };

      // Scroll to form
      this.$nextTick(() => {
        const formElement = document.querySelectorAll(".card.mb-3")[1];
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    cancelEditItem() {
      this.editingItemId = null;
      this.removeDumFile();
      this.selectedItem = {
        item_reference: "",
        currency: "MAD",
        exchange_rate: 1,
        amount_currency: "",
        priceHT: "",
        priceTTC: "",
        quantity: "",
        quantity_pcs: "",
        item_pcs: "",
        item_measuring: "",
        profit_margin: 7.0,
        remark: "",
        dum_file: null,
        dum_existing_path: "",
      };
    },
    async createNewItem() {
      if (!this.newItem.fullName) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez saisir la désignation de l'article.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("fullName", this.newItem.fullName);
      if (this.newItem.priceTTC)
        formData.append("priceTTC", this.newItem.priceTTC);
      if (this.newItem.measuring)
        formData.append("measuring", this.newItem.measuring);
      if (this.newItem.pcs) formData.append("pcs", this.newItem.pcs);

      const response = await this.$api.create(
        constant.api + "items",
        formData,
        { confirm: false }
      );

      if (response && response.data && response.data.status === "success") {
        // ItemController returns data: reference (string), not an object
        const newRef = typeof response.data.data === 'string'
          ? response.data.data
          : (response.data.data && response.data.data.reference) || null;
        await this.$store.dispatch("item/getAll");
        await this.$nextTick();
        if (newRef) {
          this.selectedItem.item_reference = newRef;
        }
        this.newItem = {
          fullName: "",
          priceTTC: "",
          measuring: "",
          equivalenceMeasure: "",
          equivalencePcs: "",
          pcs: "",
        };
        this.showNewItemForm = false;
      }
    },
    async deleteItem(item) {
      await this.$store.dispatch("consignment/destroyItem", item.id);
    },
    normalizeItemName(s) {
      return String(s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
    },
    normalizeMeasuring(s) {
      const t = String(s || "")
        .trim()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "")
        .replace(/²/g, "2")
        .replace(/³/g, "3")
        .replace(/\^/g, "");
      if (/M3|CBM/.test(t)) return "M3";
      if (/M2/.test(t)) return "M2";
      if (/^M$|MLINEAIRE|METRELINEAIRE|^ML$/.test(t)) return "M";
      if (/PCS|PCE|PIECE|PIECES|UNITE|^U$|^UN$|UNIT/.test(t)) return "PCS";
      if (/KG|KILO|KGS/.test(t)) return "Kg";
      if (/QX/.test(t)) return "Qx";
      const u = String(s || "").trim().toUpperCase();
      const allowed = ["M3", "M2", "QX", "KG", "PCS", "M"];
      if (allowed.includes(u)) return u === "KG" ? "Kg" : u === "QX" ? "Qx" : u;
      return "";
    },
    /** Clé de fusion : même article + même unité de mesure */
    measuringDedupeKey(s) {
      const m = this.normalizeMeasuring(s);
      return m || "_na_";
    },
    mergeDuplicateExtractedLines(lines) {
      const map = new Map();
      for (const raw of lines) {
        if (!raw || typeof raw !== "object") continue;
        const designation = String(raw.designation || "").trim();
        if (!designation) continue;
        const key = `${this.normalizeItemName(designation)}|${this.measuringDedupeKey(raw.measuring)}`;
        const qty = parseFloat(raw.quantity);
        const safeQty = isFinite(qty) && qty > 0 ? qty : 1;
        const th = parseFloat(raw.total_ht);
        const safeHt = isFinite(th) && th >= 0 ? th : 0;
        const up = parseFloat(raw.unit_price_ht);
        const prev = map.get(key);
        if (!prev) {
          map.set(key, { ...raw, designation, quantity: safeQty, total_ht: safeHt });
        } else {
          prev.quantity = (parseFloat(prev.quantity) || 0) + safeQty;
          prev.total_ht = (parseFloat(prev.total_ht) || 0) + safeHt;
          delete prev.unit_price_ht;
          if (!prev.measuring && raw.measuring) prev.measuring = raw.measuring;
          if (prev.quantity_pcs == null && raw.quantity_pcs != null)
            prev.quantity_pcs = raw.quantity_pcs;
          if ((prev.pcs == null || prev.pcs === "") && raw.pcs != null && raw.pcs !== "")
            prev.pcs = raw.pcs;
        }
      }
      return Array.from(map.values());
    },
    /**
     * Montant ligne en devise facture : priorité au total document, sinon PU×Qté.
     */
    computeImportLineAmounts(line) {
      const currency = this.normalizeImportCurrency(line.currency);
      const exchange_rate =
        currency === "MAD" ? 1 : parseFloat(line.exchange_rate) || 1;
      const quantity = parseFloat(line.quantity) || 1;
      const total_ht = parseFloat(line.total_ht);
      const unit_pu = parseFloat(line.unit_price_ht);

      let amount_currency = 0;
      if (isFinite(total_ht) && total_ht > 0) {
        amount_currency = total_ht;
      } else if (isFinite(unit_pu) && unit_pu >= 0 && quantity > 0) {
        amount_currency = unit_pu * quantity;
      }

      return { quantity, amount_currency, currency, exchange_rate };
    },
    async createItemForImport({ fullName, measuring = "", pcs = "" }) {
      const fromList = this.items.find((i) => i.section_reference);
      const section_reference = fromList ? fromList.section_reference : "";

      const formData = new FormData();
      formData.append("fullName", String(fullName).trim());
      if (section_reference) {
        formData.append("section_reference", section_reference);
      }
      if (measuring) formData.append("measuring", measuring);
      if (pcs !== "" && pcs != null) formData.append("pcs", String(pcs));

      const response = await this.$api.create(
        constant.api + "items",
        formData,
        { confirm: false }
      );
      if (response && response.data && response.data.status === "success") {
        const d = response.data.data;
        const ref = typeof d === "string" ? d : d && d.reference;
        await this.$store.dispatch("item/getAll");
        return ref || null;
      }
      return null;
    },
    async resolveOrCreateItemReference(line) {
      const name = String(line.designation || "").trim();
      if (!name) return null;
      const norm = this.normalizeItemName(name);
      const lineMeas = this.normalizeMeasuring(line.measuring);

      let candidates = this.items.filter(
        (i) => i.fullName && this.normalizeItemName(i.fullName) === norm
      );
      if (candidates.length === 0) {
        candidates = this.items.filter((i) => {
          if (!i.fullName) return false;
          const inorm = this.normalizeItemName(i.fullName);
          return inorm.includes(norm) || norm.includes(inorm);
        });
      }
      if (candidates.length > 0) {
        if (lineMeas) {
          const byMeas = candidates.filter(
            (i) => this.normalizeMeasuring(i.measuring) === lineMeas
          );
          if (byMeas.length) return byMeas[0].reference;
        }
        return candidates[0].reference;
      }

      const measuring = lineMeas || this.normalizeMeasuring(line.measuring);
      let pcs = "";
      if (line.pcs != null && line.pcs !== "") pcs = String(line.pcs);
      else {
        const qp = parseFloat(line.quantity_pcs);
        const q = parseFloat(line.quantity);
        if (isFinite(qp) && qp > 0 && isFinite(q) && q > 0) {
          pcs = this.formatNumberSmart(qp / q);
        }
      }
      return await this.createItemForImport({
        fullName: name,
        measuring,
        pcs,
      });
    },
    normalizeImportCurrency(currency) {
      let c = String(currency || "MAD").toUpperCase();
      if (c === "EUR") c = "EURO";
      if (!["MAD", "EURO", "USD"].includes(c)) c = "MAD";
      return c;
    },
    normalizeSupplierName(s) {
      return String(s || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ");
    },
    async resolveOrCreateSupplierReferenceByFullName(fullName) {
      const name = String(fullName || "").trim();
      if (!name) return "";

      await this.$store.dispatch("supplier/getAll");
      const suppliersList = Array.isArray(this.suppliers) ? this.suppliers : [];
      const supplierRefs = new Set(
        suppliersList.map((s) => s && s.reference).filter(Boolean)
      );
      const norm = this.normalizeSupplierName(name);
      const existing = suppliersList.find((s) => {
        const fn = s && (s.fullName || s.society || "");
        return this.normalizeSupplierName(fn) === norm;
      });
      if (existing && existing.reference) return existing.reference;

      // Create supplier using "society" as fallback identifier.
      const response = await this.$api.create(
        constant.api + "suppliers",
        { society: name },
        { confirm: false }
      );
      if (response && response.data && response.data.status === "success") {
        const created = response.data.data || {};
        await this.$store.dispatch("supplier/getAll");
        // Prefer returned reference; fallback: resolve by created.id if API returned it.
        if (created.reference) return String(created.reference);
        if (created.id) {
          const s2 = (Array.isArray(this.suppliers) ? this.suppliers : []).find(
            (s) => String(s && s.id) === String(created.id)
          );
          if (s2 && s2.reference) return String(s2.reference);
        }
      }
      // Final safety: only return a value that exists in supplier list.
      const latestList = Array.isArray(this.suppliers) ? this.suppliers : [];
      const latestRefs = new Set(
        latestList.map((s) => s && s.reference).filter(Boolean)
      );
      for (const ref of latestRefs) {
        // no-op: set created above
        void ref;
      }
      // If we cannot guarantee a valid supplier reference, omit it.
      return "";
    },
    resolveDefaultCostReference() {
      const list = Array.isArray(this.costs) ? this.costs : [];
      if (!list.length) return "";
      const preferred = list.find((c) =>
        String(c.fullName || "")
          .toUpperCase()
          .includes("FACTURE")
      );
      return (preferred || list[0]).reference || "";
    },
    async importExtractedCosts(rawCosts, options = {}) {
      const skipExisting = options.skipExisting !== false;
      const invoiceFile = options.invoiceFile instanceof File ? options.invoiceFile : null;
      const defaultSupplierFullName = String(options.supplier_fullName || "").trim();
      const defaultInvoiceNumber = String(options.invoice_number || "").trim();
      const defaultInvoiceDate = String(options.invoice_date || "").trim();
      const defaultExchangeRate = parseFloat(options.exchange_rate) || null;

      if (!Array.isArray(rawCosts) || rawCosts.length === 0) {
        return { added: 0, skipped: 0 };
      }

      await this.$store.dispatch("consignment/getAllCosts");
      const existingKeys = skipExisting
        ? new Set(
            (this.consignmentCosts || [])
              .map((c) => {
                const inv = String((c && c.invoice_number) || "").trim().toLowerCase();
                const sup = String((c && c.supplier_reference) || "").trim().toLowerCase();
                const ht = String((c && c.totalPriceHT) || "").trim();
                return `${inv}|${sup}|${ht}`;
              })
              .filter(Boolean)
          )
        : null;

      let added = 0;
      let skipped = 0;
      let attachInvoiceFile = Boolean(invoiceFile);
      const cost_reference = this.resolveDefaultCostReference();

      for (const raw of rawCosts) {
        if (!raw || typeof raw !== "object") {
          skipped += 1;
          continue;
        }

        const supplier_fullName = String(
          raw.supplier_fullName != null ? raw.supplier_fullName : defaultSupplierFullName
        ).trim();
        const invoice_number = String(
          raw.invoice_number != null ? raw.invoice_number : defaultInvoiceNumber
        ).trim();
        const invoice_date = String(
          raw.invoice_date != null ? raw.invoice_date : defaultInvoiceDate
        ).trim();
        const exchange_rate = parseFloat(
          raw.exchange_rate != null ? raw.exchange_rate : defaultExchangeRate
        );

        const supplier_reference = supplier_fullName
          ? await this.resolveOrCreateSupplierReferenceByFullName(supplier_fullName)
          : "";
        await this.$store.dispatch("supplier/getAll");
        const safeSupplierRef = (() => {
          if (!supplier_reference) return "";
          const ok = (Array.isArray(this.suppliers) ? this.suppliers : []).some(
            (s) => String(s && s.reference) === String(supplier_reference)
          );
          return ok ? supplier_reference : "";
        })();

        if (exchange_rate && isFinite(exchange_rate) && exchange_rate > 0) {
          this.consignment.exchange_rate = exchange_rate;
          if (this.selectedItem) this.selectedItem.exchange_rate = exchange_rate;
        }
        if (safeSupplierRef) {
          this.consignment.supplier_reference = safeSupplierRef;
        }

        const total_ht = parseFloat(raw.total_ht);
        const total_ttc = parseFloat(raw.total_ttc);
        const total_tva = parseFloat(raw.total_tva);
        const tva = parseFloat(raw.tva);

        const safeHT = isFinite(total_ht) && total_ht >= 0 ? total_ht : null;
        const safeTTC = isFinite(total_ttc) && total_ttc >= 0 ? total_ttc : null;
        const safeTVA = isFinite(total_tva) && total_tva >= 0 ? total_tva : null;
        const safeRate = isFinite(tva) && tva >= 0 ? tva : null;

        // If we only have HT and TVA rate, compute TTC/TVA.
        const computedTVA =
          safeTVA != null
            ? safeTVA
            : safeHT != null && safeRate != null
              ? safeHT * (safeRate / 100)
              : 0;
        const computedTTC =
          safeTTC != null
            ? safeTTC
            : safeHT != null
              ? safeHT + computedTVA
              : 0;

        const key = existingKeys
          ? `${String(invoice_number).trim().toLowerCase()}|${String(safeSupplierRef).trim().toLowerCase()}|${String(safeHT != null ? safeHT.toFixed(2) : "").trim()}`
          : "";
        if (existingKeys && key && existingKeys.has(key)) {
          skipped += 1;
          continue;
        }

        const formData = new FormData();
        if (cost_reference) formData.append("cost_reference", cost_reference);
        if (safeHT != null) formData.append("totalPriceHT", safeHT.toFixed(2));
        formData.append("totalPriceTTC", computedTTC.toFixed(2));
        formData.append("totalPriceTVA", computedTVA.toFixed(2));
        if (safeRate != null) formData.append("tva", String(safeRate));
        if (invoice_number) formData.append("invoice_number", invoice_number);
        if (invoice_date) formData.append("invoice_date", invoice_date);
        if (safeSupplierRef) formData.append("supplier_reference", safeSupplierRef);
        const remark = String(raw.remark || "").trim();
        formData.append(
          "remark",
          remark || `Import PDF — ${supplier_fullName || "Facture"}`
        );
        if (attachInvoiceFile && invoiceFile) {
          formData.append("invoice_file", invoiceFile);
        }

        try {
          await this.$store.dispatch("consignment/storeCost", formData);
          added += 1;
          attachInvoiceFile = false;
          if (existingKeys && key) existingKeys.add(key);
        } catch (e) {
          console.error(e);
          skipped += 1;
        }
      }

      await this.$store.dispatch("consignment/getAllCosts");
      return { added, skipped };
    },
    async persistImportedConsignmentItem(row, dumFile) {
      const item_reference = row.item_reference;
      const quantity = parseFloat(row.quantity) || 1;
      const amount_currency = parseFloat(row.amount_currency) || 0;
      const currency = this.normalizeImportCurrency(row.currency);
      const exchange_rate = parseFloat(row.exchange_rate) || 1;
      const profit_margin = parseFloat(row.profit_margin) || 7.0;
      const remark = row.remark || "";

      const item = this.items.find((i) => i.reference === item_reference);
      const totalPriceHT =
        currency === "MAD"
          ? amount_currency
          : amount_currency * exchange_rate;

      let totalPriceTTC = totalPriceHT;
      if (item && item.tva !== null && item.tva !== undefined) {
        const tva = parseFloat(item.tva) || 0;
        if (tva > 0) {
          totalPriceTTC = totalPriceHT + totalPriceHT * (tva / 100);
        }
      }

      const priceHT = totalPriceHT / quantity;
      const priceTTC = totalPriceTTC / quantity;

      const jsonPayload = {
        item_reference,
        currency,
        exchange_rate,
        amount_currency,
        priceHT,
        priceTTC,
        quantity,
        totalPriceHT,
        totalPriceTTC,
        profit_margin,
        remark,
      };

      if (dumFile instanceof File) {
        const formData = new FormData();
        this.appendConsignmentItemFormData(formData, {
          ...jsonPayload,
          dum_file: dumFile,
        });
        await this.$store.dispatch("consignment/storeItem", formData);
      } else {
        await this.$store.dispatch("consignment/storeItem", jsonPayload);
      }
    },
    /**
     * Remplissage / enregistrement de lignes extraites (ex. ChatPDF depuis Test.vue).
     * Déduplique par désignation + unité de mesure, crée l’article avec measuring du PDF si absent,
     * enregistre chaque ligne dans consignment_items (quantité = unité du doc, montants cohérents).
     */
    async importExtractedLines(rawLines, options = {}) {
      const dumFile = options.dumFile || null;
      const mergeDuplicates = options.mergeDuplicates !== false;
      const skipExisting = options.skipExisting !== false;
      if (!Array.isArray(rawLines) || rawLines.length === 0) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Aucune ligne d’article reconnue dans la réponse.",
        });
        return { added: 0, skipped: 0 };
      }

      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("consignment/getAllItems");
      const lines = mergeDuplicates
        ? this.mergeDuplicateExtractedLines(rawLines)
        : rawLines.filter(
            (raw) =>
              raw &&
              typeof raw === "object" &&
              String(raw.designation || "").trim().length > 0
          );
      if (!lines.length) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message:
            "Aucune ligne d’article valide (désignation requise dans chaque objet JSON).",
        });
        return { added: 0, skipped: 0 };
      }
      let added = 0;
      let skipped = 0;
      let attachFile = Boolean(dumFile);
      const existingItemRefs = skipExisting
        ? new Set(
            (this.consignmentItems || [])
              .map((ci) => ci && ci.item_reference)
              .filter(Boolean)
          )
        : null;

      for (const line of lines) {
        const itemRef = await this.resolveOrCreateItemReference(line);
        if (!itemRef) {
          skipped += 1;
          continue;
        }
        if (existingItemRefs && existingItemRefs.has(itemRef)) {
          skipped += 1;
          continue;
        }
        const fin = this.computeImportLineAmounts(line);
        if (fin.amount_currency <= 0 || fin.quantity <= 0) {
          skipped += 1;
          continue;
        }

        try {
          await this.persistImportedConsignmentItem(
            {
              item_reference: itemRef,
              quantity: fin.quantity,
              amount_currency: fin.amount_currency,
              currency: fin.currency,
              exchange_rate: fin.exchange_rate,
              profit_margin: 7.0,
              remark: `Import PDF — ${String(line.designation || "").slice(0, 100)}${
                this.normalizeMeasuring(line.measuring)
                  ? ` [${this.normalizeMeasuring(line.measuring)}]`
                  : ""
              }`,
            },
            attachFile ? dumFile : null
          );
          added += 1;
          attachFile = false;
          if (existingItemRefs) existingItemRefs.add(itemRef);
        } catch (e) {
          console.error(e);
          skipped += 1;
        }
      }

      await this.$store.dispatch("consignment/getAllItems");
      await this.$store.dispatch("notification/store", {
        status: added > 0 ? "success" : "error",
        message:
          added > 0
            ? `${added} ligne(s) ajoutée(s) au dossier.` +
              (skipped ? ` (${skipped} ignorée(s))` : "")
            : "Aucune ligne n’a pu être ajoutée.",
      });
      return { added, skipped };
    },
    /** Calcule pcs (PCS par unité) depuis une équivalence: X PCS = Y unité */
    syncNewItemPcsFromEquivalence() {
      const pcsTotal = parseFloat(String(this.newItem.equivalencePcs || "").replace(",", "."));
      const measureTotal = parseFloat(String(this.newItem.equivalenceMeasure || "").replace(",", "."));
      if (!isFinite(pcsTotal) || pcsTotal <= 0) return;
      if (!isFinite(measureTotal) || measureTotal <= 0) return;
      const pcsPerUnit = pcsTotal / measureTotal;
      this.newItem.pcs = this.formatNumberSmart(pcsPerUnit);
    },
    formatNumberSmart(value) {
      const n = parseFloat(value);
      if (!isFinite(n) || n <= 0) return "";
      return n.toFixed(10).replace(/\.?0+$/, "");
    },
    calculateItemAmounts() {
      // Centralized method to calculate all item amounts
      if (!this.selectedItem.amount_currency || this.isCalculating) {
        return;
      }

      this.isCalculating = true;

      const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
      const currency = this.selectedItem.currency || "MAD";
      const quantity = parseFloat(this.selectedItem.quantity) || 1;

      // Convert amount in currency to MAD for totalPriceHT
      const totalPriceHT =
        currency === "MAD"
          ? parseFloat(this.selectedItem.amount_currency)
          : parseFloat(this.selectedItem.amount_currency) * exchangeRate;

      // Calculate totalPriceTTC based on item's TVA
      let totalPriceTTC = totalPriceHT;
      if (this.selectedItem.item_reference) {
        const item = this.items.find(
          (item) => item.reference === this.selectedItem.item_reference
        );
        if (item && item.tva !== null && item.tva !== undefined) {
          const tva = parseFloat(item.tva) || 0;
          if (tva > 0) {
            const totalTVA = totalPriceHT * (tva / 100);
            totalPriceTTC = totalPriceHT + totalTVA;
          }
        }
      }

      // Calculate unit prices = totals / quantity
      if (quantity > 0) {
        this.selectedItem.priceHT = totalPriceHT / quantity;
        this.selectedItem.priceTTC = totalPriceTTC / quantity;
      } else {
        // No quantity yet, show totals as prices (will be divided when quantity is entered)
        this.selectedItem.priceHT = totalPriceHT;
        this.selectedItem.priceTTC = totalPriceTTC;
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
  },
  watch: {
    "selectedCost.cost_reference": function (newValue) {
      if (newValue) {
        const cost = this.costs.find((cost) => cost.reference === newValue);
        if (cost && cost.tva !== null && cost.tva !== undefined) {
          this.selectedCost.tva = cost.tva;
        }
      } else {
        this.selectedCost.tva = "";
      }
    },
    "selectedCost.totalPriceHT": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalHT = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalHT > 0) {
        if (tva === 0 || !tva) {
          // If TVA is 0, totalTTC = totalHT
          this.selectedCost.totalPriceTTC = totalHT.toFixed(2);
          this.selectedCost.totalPriceTVA = "0.00";
        } else {
          const totalTVA = totalHT * (tva / 100);
          const totalTTC = totalHT + totalTVA;

          this.selectedCost.totalPriceTVA = totalTVA.toFixed(2);
          this.selectedCost.totalPriceTTC = totalTTC.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedCost.totalPriceTTC": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalTTC = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalTTC > 0) {
        if (tva === 0 || !tva) {
          // If TVA is 0, totalHT = totalTTC
          this.selectedCost.totalPriceHT = totalTTC.toFixed(2);
          this.selectedCost.totalPriceTVA = "0.00";
        } else {
          const totalHT = totalTTC / (1 + tva / 100);
          const totalTVA = totalTTC - totalHT;

          this.selectedCost.totalPriceHT = totalHT.toFixed(2);
          this.selectedCost.totalPriceTVA = totalTVA.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedCost.totalPriceTVA": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalTVA = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalTVA >= 0) {
        if (tva === 0 || !tva) {
          // If TVA is 0, we can't calculate from totalTVA alone
          // Keep current totalHT and set totalTTC = totalHT
          const totalHT = parseFloat(this.selectedCost.totalPriceHT) || 0;
          if (totalHT > 0) {
            this.selectedCost.totalPriceTTC = totalHT.toFixed(2);
            this.selectedCost.totalPriceTVA = "0.00";
          }
        } else {
          const totalHT = totalTVA / (tva / 100);
          const totalTTC = totalHT + totalTVA;

          this.selectedCost.totalPriceHT = totalHT.toFixed(2);
          this.selectedCost.totalPriceTTC = totalTTC.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedItem.item_reference": function (newValue) {
      if (newValue) {
        const item = this.items.find((item) => item.reference === newValue);
        if (item) {
          this.selectedItem.item_pcs = item.pcs ? parseFloat(item.pcs) : "";
          this.selectedItem.item_measuring = item.measuring || "";
          this.selectedItem.quantity_pcs = "";
          // If amount_currency is set, recalculate all amounts
          if (this.selectedItem.amount_currency) {
            this.calculateItemAmounts();
          } else {
            // Auto-fill prices in MAD if available and no amount_currency is set
            if (item.priceHT) {
              this.selectedItem.priceHT = item.priceHT;
            }
            if (item.priceTTC) {
              this.selectedItem.priceTTC = item.priceTTC;
            }
          }
        }
      } else {
        this.selectedItem.item_pcs = "";
        this.selectedItem.item_measuring = "";
        this.selectedItem.quantity_pcs = "";
      }
    },
    "selectedItem.currency": function (newValue) {
      // Reset exchange rate to 1 when currency changes to MAD
      if (newValue === "MAD") {
        this.selectedItem.exchange_rate = 1;
      }
    },
    "selectedItem.exchange_rate": function (newValue) {
      // Auto-update if currency is MAD, exchange rate should be 1
      if (this.selectedItem.currency === "MAD") {
        this.selectedItem.exchange_rate = 1;
        return;
      }
      // Recalculate all amounts when exchange rate changes (only if not calculating and amount_currency exists)
      if (!this.isCalculating && this.selectedItem.amount_currency) {
        this.isCalculating = true;
        this.$nextTick(() => {
          this.calculateItemAmounts();
          this.isCalculating = false;
        });
      }
    },
    "selectedItem.amount_currency": function (newValue) {
      // Calculate all amounts automatically when amount in currency is entered
      if (newValue) {
        this.calculateItemAmounts();
      } else {
        // Clear related fields if amount is cleared
        this.selectedItem.priceHT = "";
        this.selectedItem.priceTTC = "";
      }
    },
    "selectedItem.quantity": function (newValue) {
      if (newValue && this.selectedItem.amount_currency) {
        this.calculateItemAmounts();
      }
      if (newValue && this.selectedItem.item_pcs > 0 && !this.isCalculatingQty) {
        this.isCalculatingQty = true;
        this.selectedItem.quantity_pcs = (
          parseFloat(newValue) * parseFloat(this.selectedItem.item_pcs)
        ).toFixed(0);
        this.$nextTick(() => { this.isCalculatingQty = false; });
      }
    },
    "selectedItem.quantity_pcs": function (newValue) {
      const pcs = parseFloat(this.selectedItem.item_pcs);
      if (newValue && pcs > 0 && !this.isCalculatingQty) {
        this.isCalculatingQty = true;
        this.selectedItem.quantity = (parseFloat(newValue) / pcs).toFixed(4);
        this.$nextTick(() => { this.isCalculatingQty = false; });
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch("consignment/getAllCosts");
    await this.$store.dispatch("consignment/getAllItems");
    await this.$store.dispatch("society/getAll");
    await this.$store.dispatch("cost/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("supplier/getAll");
  },
};
</script>
